import React from 'react';
import { FormContext, useForm } from 'react-hook-form';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { DECLINATION_REASONS_FIELD_NAMES } from './DeclinationReasons.constants';
import { ReasonsSelector } from './ReasonsSelector';

const { declinationReasons: STRINGS } = strings.sendoutsV2.form.sections;

export const DeclinationReasonsDrawerBase = ({
  buildPayload,
  commentsLabel = STRINGS.commentsLabel,
  commentsPlaceholder = STRINGS.commentsLabel,
  defaultValues,
  hasReasonsError = false,
  isLoadingReasons = false,
  isSubmitting = false,
  onClose = () => {},
  onRetryReasons,
  onSaved = () => {},
  reasons = [],
  reasonsErrorMessage = STRINGS.catalogUnavailable,
  reasonsValidationMessage = STRINGS.reasonsValidationMessage,
  subtitle = STRINGS.subtitle,
  title
}) => {
  const form = useForm({ defaultValues });
  const { handleSubmit } = form;

  const handleSave = async data => {
    await onSaved({ payload: buildPayload(data) });
  };

  const isSaveDisabled = isSubmitting || isLoadingReasons || hasReasonsError;

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.cancel,
        variant: 'outlined',
        onClick: onClose,
        disabled: isSubmitting
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: strings.shared.ui.save,
        variant: 'contained',
        onClick: handleSubmit(handleSave),
        disabled: isSaveDisabled,
        isSaving: isSubmitting
      },
      GridItemProps: { md: 3 },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <FormContext {...form}>
        <ReasonsSelector
          commentsFieldName={DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes}
          commentsLabel={commentsLabel}
          commentsPlaceholder={commentsPlaceholder}
          hasReasonsError={hasReasonsError}
          isLoadingReasons={isLoadingReasons}
          onRetryReasons={onRetryReasons}
          reasons={reasons}
          reasonsErrorMessage={reasonsErrorMessage}
          reasonsFieldName={DECLINATION_REASONS_FIELD_NAMES.DeclinedFields}
          reasonsValidationMessage={reasonsValidationMessage}
          subtitle={subtitle}
        />
      </FormContext>
    </FPDrawer>
  );
};
